import { render, staticRenderFns } from "./CommonProfileNew.vue?vue&type=template&id=f488b450&scoped=true&"
import script from "./CommonProfileNew.vue?vue&type=script&lang=js&"
export * from "./CommonProfileNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f488b450",
  null
  
)

export default component.exports